import { composeIO } from 'react-compose-io'
import { titulosGeradosIO } from './TitulosGerados.IO'
import { TitulosGeradosView } from './TitulosGerados.View'

export const TitulosGerados = composeIO(TitulosGeradosView, titulosGeradosIO)
